import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import qs from "qs";

import { getAmountToDisplay } from "../SuccessScreen/getAmountToDisplay";

export function useGetPaymentTypeVerbiage(paymentType) {
  const { state } = usePaymentPage();
  const location = useLocation();
  const amountToDisplay = getAmountToDisplay(state);

  const [verbiage, setVerbiage] = useState({});

  let addOnTotal = 0;
  (state?.addOnAmounts || []).forEach((a) => {
    if (a.isChecked) addOnTotal += parseFloat(a.amount);
  });

  // const addOnTotalFormatted =
  //   addOnTotal && state?.amount
  //     ? `${new Intl.NumberFormat("en-US", {
  //         style: "currency",
  //         currency: "USD",
  //       }).format(parseFloat(state?.amount || 0) + addOnTotal)} `
  //     : "";

  const addOnTotalFormatted =
    state?.amount && addOnTotal > 0 ? `$${amountToDisplay} ` : "";

  useEffect(() => {
    const { isSuggestedDonation: suggestedDonationParam } = qs.parse(
      location.search,
      {
        ignoreQueryPrefix: true,
      }
    );
    let type = paymentType || state.fund.paymentPageSettings?.paymentType;
    if (suggestedDonationParam === "true") {
      type = "donation";
    }

    switch (type?.toLowerCase()) {
      case "gift":
        return setVerbiage({
          leadText: "Make a Gift To",
          introButtonText: "Give Now!",
          verb: "give",
          noun: "gift",
          nounCap: "Gift",
          submitButtonText: `Give ${addOnTotalFormatted}Securely`,
        });
      case "payment":
        return setVerbiage({
          leadText: "Make a Payment Toward",
          introButtonText: "Make a Payment",
          verb: "pay",
          noun: "payment",
          nounCap: "Payment",
          submitButtonText: `Pay ${addOnTotalFormatted}Securely`,
        });
      case "signup":
        return setVerbiage({
          leadText: "For your signup to",
          introButtonText: "Make a Payment",
          verb: "pay",
          noun: "payment",
          nounCap: "Payment",
          submitButtonText: `Pay ${addOnTotalFormatted}Securely`,
        });
      case "donation":
      default:
        return setVerbiage({
          leadText: "Make a Donation To",
          introButtonText: "Donate Now!",
          verb: "donate",
          noun: "donation",
          nounCap: "Donation",
          submitButtonText: `Donate ${addOnTotalFormatted}Securely`,
        });
    }
  }, [
    state.fund.paymentPageSettings?.paymentType,
    paymentType,
    location.search,
    addOnTotalFormatted,
  ]);

  return verbiage;
}
